import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {User} from './user';
import {environment} from '../../../environments/environment';

@Injectable()
export class SigninService {

  private VISIOTEX_BASE_URL = environment.visiotexBaseURL;

  constructor(private httpClient: HttpClient) {
  }

  login(user: User): Observable<any> {
    return this.httpClient.post<any>(this.VISIOTEX_BASE_URL + '/info/DossierService.svc/GetDossierInsurerPost', user);
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/signin/signin.service.ts